import { Box, IconButton, TextField, Tooltip } from "@mui/material";
import { formatBrazilianPhone, generateRandomHash } from "../core";
import { useRef, useState } from "react";
import { Delete } from "@mui/icons-material";

export interface PhonesEditorProps {
  phones: string;
  onEdit: (phones: string) => void;
}

export const PhonesEditor: React.FC<PhonesEditorProps> = ({ phones, onEdit }) => {
  const [usePhones, setPhones] = useState<string>(phones);

  return <Box sx={{
    flex: 1,
    gap: "0.5em",
    display: "flex",
    flexDirection: "column",
  }}  >
    {usePhones.split(";").map((val, idx) => {
      return <Item
        key={generateRandomHash(8)}
        value={formatBrazilianPhone(val)}
        onChange={(value) => {
          const values = usePhones.split(";");
          values[idx] = value;
          setPhones(values.join(";"));
          onEdit(values.join(";"));
        }}
        onRemove={() => {
          const values = usePhones.split(";").filter((_, i) => i !== idx);
          setPhones(values.join(";"));
          onEdit(values.join(";"));
        }}
      />;
    })}
  </Box>;
};



interface ItemProps {
  label?: string;
  value: string;
  onChange?: (value: string) => void;
  onRemove?: () => void;
}
const Item: React.FC<ItemProps> = ({ value, label, onChange, onRemove }) => {
  const timer = useRef<NodeJS.Timer>();
  const [textValue, setTextValue] = useState(value);

  const handleChange = (value: string) => {
    if (timer.current) clearTimeout(timer.current);
    setTextValue(value);

    timer.current = setTimeout(() => {
      if (onChange) onChange(value);
    }, 1000);
  };

  return <Box sx={{
    display: "flex",
    flexDirection: "row",
  }}>
    <TextField
      fullWidth
      label={label}
      variant="standard"
      value={textValue}
      onChange={(ev) => handleChange(ev.target.value)}
    />
    <Tooltip title="Remover">
      <IconButton size="small" onClick={onRemove}>
        <Delete fontSize="small" />
      </IconButton>
    </Tooltip>
  </Box>;
};